<h1 mat-dialog-title>@if (isModeCreate()) { Create a new User } @else { Update User }</h1>

<mat-dialog-content>
    <app-edit-user #editUserComponent [data]="data" />
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary"
            [disabled]="!isSaveButtonEnabled()"
            (click)="performSave()">Save</button>
</mat-dialog-actions>
